import { SEARCH_STATE_PARAMS } from '@xing-com/crate-jobs-constants';
import type { FilterName } from '@xing-com/crate-jobs-domain-search-types';

type FilterTypename =
  | 'JobFilterCareerLevel'
  | 'JobFilterCity'
  | 'JobFilterCompany'
  | 'JobFilterCountry'
  | 'JobFilterDiscipline'
  | 'JobFilterEmploymentType'
  | 'JobFilterIndustry'
  | 'JobFilterRemoteOption';

export const FILTER_TYPENAME_TO_NAME: Record<FilterTypename, FilterName> = {
  JobFilterCareerLevel: SEARCH_STATE_PARAMS.careerLevel,
  JobFilterCity: SEARCH_STATE_PARAMS.city,
  JobFilterCompany: SEARCH_STATE_PARAMS.company,
  JobFilterCountry: SEARCH_STATE_PARAMS.country,
  JobFilterDiscipline: SEARCH_STATE_PARAMS.discipline,
  JobFilterEmploymentType: SEARCH_STATE_PARAMS.employmentType,
  JobFilterIndustry: SEARCH_STATE_PARAMS.industry,
  JobFilterRemoteOption: SEARCH_STATE_PARAMS.remoteOption,
} as const;
